(() => {
  const SELECTOR = '[data-ccsw-site-header]';

  function initHeader(root) {
    if (!root || root.dataset.ccswInitialized === 'true') return;
    root.dataset.ccswInitialized = 'true';

    const openButton = root.querySelector('[data-ccsw-drawer-open]');
    const closeButton = root.querySelector('[data-ccsw-drawer-close]');
    const drawer = root.querySelector('[data-ccsw-drawer]');
    const overlay = root.querySelector('[data-ccsw-drawer-overlay]');

    if (!openButton || !closeButton || !drawer || !overlay) return;

    let lastFocused = null;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    function openDrawer() {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ccsw-site-drawer-open');

      const firstFocusable = drawer.querySelector(focusableSelector);
      if (firstFocusable) window.setTimeout(() => firstFocusable.focus(), 30);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ccsw-site-drawer-open');

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function trapFocus(event) {
      if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;

      const focusable = Array.from(drawer.querySelectorAll(focusableSelector)).filter(
        (element) => element.offsetParent !== null
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    openButton.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
      trapFocus(event);
    });

    drawer.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => {
        if (drawer.classList.contains('is-open')) closeDrawer();
      });
    });

    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const handleDesktopChange = (event) => {
      if (event.matches && drawer.classList.contains('is-open')) closeDrawer();
    };

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', handleDesktopChange);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(handleDesktopChange);
    }

    async function refreshCart() {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        const cart = await response.json();
        const count = root.querySelector('[data-ccsw-cart-count]');
        const total = root.querySelector('[data-ccsw-cart-total]');

        if (count) {
          count.textContent = String(cart.item_count || 0);
          count.hidden = !cart.item_count;
        }

        if (total && window.Shopify?.formatMoney) {
          total.textContent = window.Shopify.formatMoney(cart.total_price);
        }
      } catch (_error) {
        // Keep the server-rendered cart values when the cart endpoint is unavailable.
      }
    }

    document.addEventListener('cart:updated', refreshCart);
    document.addEventListener('cart:refresh', refreshCart);
    document.addEventListener('ccsw:cart:updated', refreshCart);
  }

  function initWithin(scope = document) {
    if (scope.matches?.(SELECTOR)) initHeader(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document));
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();
